import MapFilter from './MapFilter'

export default MapFilter
